export default __webpack_public_path__ + "static/media/card-image-thumbnail.d446a4ea.svg";